module.exports = __webpack_public_path__ + "img/logincolor.14f41ea4.png";